interface ApiConfigInterface {
  readonly apiRoot: string;
  readonly imageUrl: string;
  readonly editorUrl: string;
  readonly environment: 'PREVIEW' | 'LIVE';
}

const HOSTNAME = window?.location?.hostname;

const isLiveServer =
  HOSTNAME === 'live-bp.factor-eleven.com' ||
  HOSTNAME === 'live.content-engagement-ad.com' ||
  HOSTNAME === 'ad-production-stage.com' ||
  HOSTNAME === 'www.ad-production-stage.com';

const devConfig: ApiConfigInterface = {
  apiRoot: '//cea-api-dev.factor-eleven.de/graphql',
  imageUrl: '//cea-api-dev.factor-eleven.de/image/',
  editorUrl: '//cea-builder-dev.factor-eleven.de/',
  environment: 'PREVIEW',
};

const prodConfig: ApiConfigInterface = {
  apiRoot: '//cea-api-show.factor-eleven.de/graphql',
  imageUrl: '//cea-api-show.factor-eleven.de/image/',
  editorUrl: '//cea-builder-show.factor-eleven.de/',
  environment: 'LIVE',
};

export const ApiConfig: ApiConfigInterface = isLiveServer ? prodConfig : devConfig;
